import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import { withTUXIcon } from './withTUXIcon.js';
import * as React from 'react';

function IconExclamationMarkTriangleFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor"
  }, props, {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    className: props.className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.55 6.92a4 4 0 016.9 0l16.5 28.05A4 4 0 0140.5 41h-33a4 4 0 01-3.45-6.03l16.5-28.05zM24 8.94L7.5 37h33L24 8.94zM22 18a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1h-2a1 1 0 01-1-1v-9zm2 17a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
  }));
}
var TUXIconExclamationMarkTriangleFill = withTUXIcon(IconExclamationMarkTriangleFill);

export default IconExclamationMarkTriangleFill;
export { TUXIconExclamationMarkTriangleFill };
